module.exports = __webpack_public_path__ + "static/img/floor2-bgq.56e19f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-bgq.png
// module id = FwY0
// module chunks = 1